import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Capability } from '@uigy/generated/graphql';
import { MiniLayoutWithButton } from '@uigy/modules/mini-layout/models/mini-layout';
import { ToasterType } from '@uigy/shared/components/toaster/enums/toaster-type.enum';
import { ToasterService } from '@uigy/shared/components/toaster/services/toaster.service';
import { LanguageService } from '@uigy/shared/services/language.service';
import { StatusDataService } from '@uigy/shared/services/statusData.service';
import { MakeApiRequest } from '@uigy/shared/store/api-rquest-handeler/api-request-handler-actions';
import { ApiCallType } from '@uigy/shared/store/api-rquest-handeler/model/api-call.interface';
import { GetStatusAction } from '@uigy/store/actions/auth.actions';
import { State } from '@uigy/store/appState';

@Component({
    selector: 'app-enable-page',
    templateUrl: './enable-page.component.html',
    standalone: false
})
export class EnablePageComponent {
  public isRunning: boolean = false;
  public text: MiniLayoutWithButton = this.languageService.texts.mini_layout_pages.enable;
  public capability = Capability.SystemSettings;

  constructor(private store: Store<State>,
              private StatusDataService: StatusDataService,
              private router: Router,
              private toasterService: ToasterService,
              private languageService: LanguageService) {
  }

  public enable(): void {
    this.isRunning = true;
    this.store.dispatch(new MakeApiRequest({
      type: ApiCallType.GQLType,
      job: this.StatusDataService.setStatus(true),
      onFailure: (): void => {
        this.isRunning = false;
        this.toasterService.openToaster({
          message: this.languageService.errorTexts.generic_error_msg,
          type: ToasterType.Error
        });
      },
      onSuccess: (): void => {
        this.isRunning = false;
        this.store.dispatch(new GetStatusAction());
      }
    }));
  }
}
